import { hasValue } from '@util';
import { DataGridColumn } from 'ngrx-data-grid';
import * as R from 'ramda';

const sortColumns = (columnsOrder: string[], columns: DataGridColumn[]) => {
  const commonColumns = R.filter(column => R.includes(column.field, columnsOrder), columns);
  return <DataGridColumn[]>R.sortBy(R.pipe(R.prop('field'), R.indexOf(R.__, columnsOrder)))(commonColumns);
};

const findColumnsWithoutOrder = (columnsOrder: string[], columns: DataGridColumn[]) =>
  hasValue(columnsOrder) ? R.filter(column => !R.includes(column.field, columnsOrder), columns) : [];

export const reorderColumns = (columnsOrder: string[], columns: DataGridColumn[]): DataGridColumn[] => {
  const reorderedColumns = hasValue(columnsOrder) ? sortColumns(columnsOrder, columns) : columns;
  const columnsWithoutColumnOrder = findColumnsWithoutOrder(columnsOrder, columns);
  return R.concat(reorderedColumns, columnsWithoutColumnOrder);
};
